<template>
    <div>
        <h1 v-if="$i18n.locale=='en'">{{$t('labels.keyFigure')}}</h1>
        <VueSlickCarousel v-bind="sliderSettingsBg" ref="carousel" class="main-slider">
            <div class="slide" v-for="(slide,i) in data.slides" :key="i">
                <div class="row">
                    <div class="col" v-for="(stats,a) in slide.data" :key="a" >
                        <div class="icon" v-if="stats.icon">
                            <img :src="require(`@/assets/images/business-operations/${stats.icon}`)">
                        </div>
                        <span v-html="stats.title"></span>
                        
                       <span class="text-lowercase" v-html="stats.number"></span>
                    </div>
                </div>
            </div>
          </VueSlickCarousel>
    </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
    export default {
        props:{
            data: Object
        },
        components:{
            VueSlickCarousel
        },
        data() {
            return {
                sliderSettingsBg: {
                slidesToShow: 1,
                slideToScroll: 1,
                dots: true,
                arrows:true,
                cssEase: "cubic-bezier(0.670, 0.965, 1.000, 1.000)",
                speed: 800,
                infinite: false,
                loop:false,
                focusOnSelect: true,
                swipeToSlide: true,
                prevArrow: this.$refs.prevous,
                nextArrow: this.$refs.next,
                },
            };
        },
    }
</script>

<style lang="scss" scoped>
    h1{
        font-size:rem(30px);
        text-align:center;
        text-transform: uppercase;
        color: #707070;
        margin-bottom:rem(60px);
    }
    /deep/{
    .text-unset{
        text-transform: none !important;
    }
    }
    .main-slider{
        padding: rem(60px) rem(50px) rem(100px) rem(50px);
        margin-bottom:rem(40px);
        position:relative;
        /deep/{
            .slick-arrow{
                background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg fill='%23707070' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 35 64.806' %3e%3cg id='glanceNext'%3e%3cg id='next' transform='translate(-117.742 0)' opacity='1'%3e%3cg id='Group_1' data-name='Group 1' transform='translate(117.742 0)'%3e%3cpath id='Path_1' data-name='Path 1' d='M152,30.625,122.029.733a2.512,2.512,0,0,0-3.548,3.558L146.672,32.4,118.48,60.516a2.512,2.512,0,0,0,3.548,3.557L152,34.182a2.511,2.511,0,0,0,0-3.557Z' transform='translate(-117.742 0)' fill='%23707070'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/svg%3e");
                background-repeat: no-repeat;
                width: 22px;
                height: 42px;
                background-size: 100%;
                &.slick-disabled{
                    opacity:.5 !important;
                    pointer-events: none;
                }
                &.slick-prev{
                    transform:translate(0, -50%) rotate(180deg);
                    left:22px;
                }
                &.slick-next {
                    right: 22px;
                }
                &:before{
                    display:none;
                }
                
            }
            .slick-dots {
                bottom:0;
                li{
                    &.slick-active {
                        button{
                            &:before{
                                color:#4eb9e9;
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width:991px){
            padding: rem(40px) rem(20px) rem(60px) rem(20px);
            /deep/{
                .slick-arrow{
                    width: 15px;
                    height: 35px;
                    &.slick-prev{
                        left:0px;
                    }
                    &.slick-next {
                        right: 0px;
                    }
                }
            }
        }
        @media screen and (max-width:575px){
            .row{
                justify-content:center;
                >div{
                    max-width:50%;
                    flex: 0 0 50%;
                    margin-bottom:rem(30px);
                }
            }
        }
    }
</style>